import { Popup } from '@mairistem/composants';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import type RegleCalcul from '../../../../interfaces/simulation/regleCalcul';
import CalculPropositionModalPopupContent from './CalculPropositionModalPopupContent';
import './CalculPropositionModalPopup.css';

interface CalculPropositionModalPopupProps {
	anneeExercice: number;
	regleCalcul: RegleCalcul;
}

const CalculPropositionModalPopup = ({
	anneeExercice,
	regleCalcul,
}: CalculPropositionModalPopupProps) => (
	<Popup
		className="calculPropositionPopup"
		content={
			<CalculPropositionModalPopupContent
				anneeExercice={anneeExercice}
				disabled
				lignesRegleCalcul={regleCalcul?.lignes}
				typeCalcul={regleCalcul?.typeCalcul}
			/>
		}
		data-testid="regleCalculPopup"
		offset={[8, 0]}
		on="click"
		position="bottom right"
		trigger={
			<Icon
				cursor="pointer"
				data-testid="regleCalculIconPopup"
				iconSet="Lucide"
				name="Info"
			/>
		}
		wide="very"
	/>
);

export default CalculPropositionModalPopup;
